import type { SVGProps } from 'react';
const SvgNavChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height={24}
    fill="none"
    width={24}
    {...props}
  >
    <path
      d="m11 18-6-6 6-6 1.4 1.4L7.825 12l4.575 4.6zm6.6 0-6-6 6-6L19 7.4 14.425 12 19 16.6z"
      fill="currentColor"
    />
  </svg>
);
export default SvgNavChevronLeft;
